module.exports = __webpack_public_path__ + "img/lb.23f8594.svg";